import { render, staticRenderFns } from "./PacketFolder.vue?vue&type=template&id=26882156&"
import script from "./PacketFolder.vue?vue&type=script&lang=js&"
export * from "./PacketFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports